import React from "react";

const EmptyStateCard = ({
  icon,
  title,
  description,
  buttonLabel,
  className,
  onAction = () => {},
  hideButton = false,
}) => {
  return (
    <div
      className={`w-full flex flex-col items-center justify-center py-16 px-4 bg-white rounded-xl border border-[#d0d0d0] dark:bg-navy-800 ${className}`}
    >
      {/* Optional Icon */}
      {icon && <div className="mb-6">{icon}</div>}

      {/* Title */}
      {title && (
        <h2 className="text-[20px] font-semibold text-[#000] dark:text-white mb-2 text-center">
          {title}
        </h2>
      )}

      {/* Description */}
      {description && (
        <p className="text-[15px] text-[#808080] font-medium dark:text-gray-300 mb-6 text-center max-w-md">
          {description}
        </p>
      )}

      {/* CTA Button */}
      {!hideButton && buttonLabel && (
        <button
          onClick={onAction}
          className="bg-[#000] hover:bg-[#393939] text-white font-semibold px-4 py-2 rounded-md transition duration-200"
        >
          {buttonLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyStateCard;
